import React from 'react';
import { HelpCircle } from 'lucide-react';
import { CTAButton } from './CTAButton';
const faqs = [{
  q: '¿Necesito experiencia previa?',
  a: 'No. El material fue diseñado para principiantes.'
}, {
  q: '¿Necesito tener un local?',
  a: 'No. Podés comenzar desde tu casa.'
}, {
  q: '¿Cuándo recibo el acceso?',
  a: 'Inmediatamente después del pago.'
}, {
  q: '¿Puedo verlo desde el celular?',
  a: 'Sí. Desde celular, tablet o computadora.'
}, {
  q: '¿Las fórmulas son difíciles?',
  a: 'No. Están explicadas paso a paso.'
}, {
  q: '¿El acceso vence?',
  a: 'No. Es acceso de por vida.'
}];
export function FAQ() {
  return <section className="py-8 md:py-16 px-4 bg-dark-800 border-t border-dark-700" data-id="element-49">
      <div className="max-w-4xl mx-auto" data-id="element-50">
        <div className="text-center mb-10 md:mb-12" data-id="element-51">
          <h2 className="text-xl md:text-5xl font-black text-white mb-3 md:mb-4 uppercase flex items-center justify-center gap-2 md:gap-3 leading-snug" data-id="element-52">
            <HelpCircle className="text-brand-400 w-6 h-6 md:w-12 md:h-12 shrink-0" data-id="element-53" />
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-12" data-id="element-54">
          {faqs.map((faq, i) => <div key={i} className="bg-dark-900 p-5 md:p-6 rounded-xl border border-dark-700 shadow-sm" data-id="element-55">
              <h3 className="font-bold text-brand-400 text-lg mb-2" data-id="element-56">{faq.q}</h3>
              <p className="text-gray-300 font-medium" data-id="element-57">{faq.a}</p>
            </div>)}
        </div>

        <div className="text-center max-w-3xl mx-auto bg-dark-900 p-6 md:p-10 rounded-3xl border-2 border-dark-700 shadow-xl" data-id="element-58">
          <p className="text-lg md:text-xl text-gray-300 font-medium mb-4" data-id="element-59">
            Este sistema fue creado para personas reales que quieren comenzar un
            emprendimiento con una inversión baja y una guía clara.
          </p>
          <p className="text-lg md:text-xl text-red-400 font-bold mb-4" data-id="element-60">
            No promete resultados mágicos.
          </p>
          <p className="text-xl md:text-2xl text-white font-black mb-8" data-id="element-61">
            Te brinda el conocimiento, las fórmulas y el sistema para que puedas
            avanzar mucho más rápido.
          </p>
          <div className="flex justify-center" data-id="element-62">
            <CTAButton className="text-dark-900" data-id="element-63" />
          </div>
        </div>
      </div>
    </section>;
}